module.exports = __webpack_public_path__ + "img/rain.e3eb4f73.svg";